// 메신저(MM) iframe 에 주입하는 '스티커 표시 크기' CSS — 대화에 보낸 스티커를 최대 120px 로 줄인다.
// 왜 CSS 주입인가: 단일 이미지 미리보기(.file-view--single)는 MM 웹앱 마크업이라 우리가 고칠 수 없고,
//    같은 오리진 iframe 이라 통제 지점은 그 문서의 style 요소뿐이다(mmModalCss·mmPostEditCss 선례).
// 왜 이 셀렉터로 스티커만 골라지나: MM 11.11 은 첨부 썸네일 img 의 aria-label 을
//    `formatMessage({id:"file_attachment.thumbnail"}) + " " + file.name.toLowerCase()` 로 만든다
//    (DEV 번들 9748.*.js 실측) → aria-label 끝에 '공백 + 소문자 파일명' 이 붙는다.
//    스티커 파일명은 `sticker_<팩>_<id>.<확장자>`(StickerPicker.jsx) 다.
// 🔴 `" sticker_"` 앞의 공백 한 칸은 의도다 — 공백을 넣어야 파일명 '시작' 에 고정된다
//    (`photo_sticker_1.png` 같은 이름 중간 일치를 막는다 · 앞의 로캘 문구가 무엇이든 무관).
// 🔴 @media 를 두지 않는다 — 데스크톱·모바일 모두 같은 크기(마스터 2026-10-01 «110px로 발주해» → 같은 날 120px 로 재조정).
// 🔴 범위를 .file-view--single 안으로 한정한다 — 클릭해 여는 미리보기 모달(원본 크기·확대)과
//    여러 장 갤러리 타일은 대상이 아니다. 원본 파일·업로드·전송은 그대로고 표시만 줄인다.
// 🔴 상한값(120px)을 바꿀 때 같이 고칠 네 곳: 이 파일의 max-width/max-height · 머리 주석,
//    mmStickerSizeCss.test.js 의 값 단언, EmbedPage.jsx 메신저 분기 두 줄의 주석 꼬리,
//    tests/e2e/test_embeds_smoke.py 의 STICKER_MAX_PX·옛값 금지 단언·비율(세로) 기대값.
export const MM_STICKER_STYLE_ID = 'gw-mm-sticker-size-css';

export const MM_STICKER_SIZE_CSS = [
  '.file-view--single img[aria-label*=" sticker_"]{',
  // max-* 로만 누르고 width/height 는 auto — 원본 비율을 유지한 채 긴 변이 120px 가 된다.
  'max-width:120px !important;max-height:120px !important;',
  'width:auto !important;height:auto !important;object-fit:contain',
  '}',
].join('');

// style#gw-mm-sticker-size-css 를 head 에 '1개만' 유지한다. 폴링 루프(50ms×120)+onLoad 가 반복
// 호출하므로 멱등이 필수 — 이미 있으면 새로 만들지 않고 내용이 달라졌을 때만 갱신한다.
// doc·head 가 없으면(로드 중 문서) 조용히 no-op — applyMmPostEditCss 와 같은 형태.
export function applyMmStickerSizeCss(doc) {
  if (!doc || !doc.head) return;
  const found = doc.getElementById(MM_STICKER_STYLE_ID);
  if (found) {
    if (found.textContent !== MM_STICKER_SIZE_CSS) found.textContent = MM_STICKER_SIZE_CSS;
    return;
  }
  const st = doc.createElement('style');
  st.id = MM_STICKER_STYLE_ID;
  st.textContent = MM_STICKER_SIZE_CSS;
  doc.head.appendChild(st);
}
